// Copyright (c) 2017 Deere & Company

import AuditRecording, {getDefaultState as getAuditRecordingDefaultState} from '@deere/cps-it.warranty-model-factory/lib/audit-recording';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Debit, {getDefaultState as getDebitDefaultState} from '@deere/cps-it.warranty-model-factory/lib/debit';
import t from 'tcomb';

const State = t.struct({
    auditRecording: AuditRecording,
    busyCounter: BusyCounter,
    fullDebitItemToUpdate: Debit,
    isConfirmationModalVisible: t.Boolean,
    isFullDebitModalVisible: t.Boolean,
    isRecordAuditModalVisible: t.Boolean
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        auditRecording: getAuditRecordingDefaultState(),
        busyCounter: getBusyCounterDefaultState(),
        fullDebitItemToUpdate: getDebitDefaultState(),
        isConfirmationModalVisible: false,
        isFullDebitModalVisible: false,
        isRecordAuditModalVisible: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/state/index.js